import React, {useContext, useEffect, useState} from "react";
import {TranslateContext} from "../../context/TranslateContext";
import {eliminaCommentoApi, getCommentiKpiApi, setUltimaLetturaCommentiKpiApi} from "./services/CommentiServices";
import CommentiKpiView from "./CommentiKpiView";

export default function CommentiKpiController({
                         parentTab,
                         parentPaginaTab,
                         idKpi = null,
                         idTipoImportDati = null,
                         updateKpiCompPadre = () => {
                         },
                         countUpdate
                     }) {

    const [commenti, setCommenti] = useState([]);
    const [loading, setLoading] = useState(true);
    const [commentoSel, setCommentoSel] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState('');

    const {translate} = useContext(TranslateContext);

    useEffect(() => {
        if (idKpi) {
            getCommentiKpi(idKpi);
            setUltimaLetturaCommenti(idKpi);
        }
    }, [idKpi]);


    useEffect(() => {
        if (countUpdate && countUpdate > 0) {
            getCommentiKpi(idKpi);
        }
    }, [countUpdate]);

    const getCommentiKpi = async (idKpi) => {
        const response = await getCommentiKpiApi(idKpi, idTipoImportDati);
        setCommenti(response.data.data);
        setLoading(false);
    }

    async function setUltimaLetturaCommenti(idKpi) {
        await setUltimaLetturaCommentiKpiApi(idKpi, idTipoImportDati);
        updateKpiCompPadre();
    }

    const eliminaCommento = async () => {
        setShowConfirm(false);

        const response = await eliminaCommentoApi(commentoSel.id_commento_kpi);
        if (response.data.result === 0) {
            // ricarico per vedere il risultato del delete
            getCommentiKpi(idKpi);
            updateKpiCompPadre();
        }
        setModalMsg(response.data.description);
    }

    function handleDeleteCommento(commento) {
        setCommentoSel(commento);
        setShowConfirm(true);
    }

    return (
        <CommentiKpiView
            translate={translate}
            commenti={commenti}
            eliminaCommento={eliminaCommento}
            loading={loading}
            modalMsg={modalMsg}
            parentPaginaTab={parentPaginaTab}
            parentTab={parentTab}
            show={show}
            setShow={setShow}
            showConfirm={showConfirm}
            setShowConfirm={setShowConfirm}
            handleDeleteCommento={handleDeleteCommento}
        />
    );
}
